import NumberSuffix from '../modules/numberSuffixBuilder.js'

const NUMERIC_GRADES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

export const gradeText = (grade?: string) => {
  if (NUMERIC_GRADES.includes(grade)) {
    return `${NumberSuffix(grade)} grade`
  }

  return grade && grade !== 'Other' ? grade : 'Other grade'
}

export default gradeText
